import { Alert, Button } from 'reactstrap'
import PropTypes from 'prop-types'
import { useState } from 'react'

const MessageBannerActionButton = ({ controlOption, messageType, index }) => {
  const [hover, setHover] = useState(false)
  const colorMap = {
    warning: '#847320',
    //future scope: can add configuration for other theme as well
  }
  const baseColor = colorMap[messageType]
  const isOutlineButton = controlOption.varient === 'outline'
  const buttonStyle = isOutlineButton
    ? {
      backgroundColor: hover ? baseColor : 'transparent',
      color: hover ? '#fff' : baseColor,
      border: `1px solid ${baseColor}`,
      transition: 'all 0.2s ease',
    }
    : {
      backgroundColor: baseColor,
      color: '#fff',
      border: 'none',
    }

  const isNotFirstButton = index > 0

  return (
    <Button
      outline={isOutlineButton}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      data-test="buttons.alert-link"
      style={buttonStyle}
      onClick={controlOption.handleClick}
      className={`mr-2 ${isNotFirstButton && 'mt-2 mt-lg-0'}`}
    >
      {controlOption.label}
    </Button>
  )
}

MessageBannerActionButton.propTypes = {
  controlOption: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      handleClick: PropTypes.func.isRequired,
      varient: PropTypes.oneOf(['outline', 'solid']),
    })
  ),
  messageType: PropTypes.oneOf([
    'primary',
    'secondary',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
  ]),
  index: PropTypes.number
}

const MessageBanner = ({
  heading,
  messageType,
  shouldShowControlOption,
  controlOptions,
  children,
}) => {
  return (
    <Alert color={messageType} className="mt-3">
      {heading && (
        <>
          <h4 className='font-weight-bold'>{heading}</h4>
          <hr />
        </>
      )}
      {children}
      {shouldShowControlOption && (
        <div className="d-flex align-items-between mt-2 flex-column flex-lg-row">
          {controlOptions.map((controlOption, index) => {
            return (
              <MessageBannerActionButton
                controlOption={controlOption}
                messageType={messageType}
                index={index}
              />
            )
          })}
        </div>
      )}
    </Alert>
  )
}




MessageBanner.propTypes = {
  heading: PropTypes.string,
  messageType: PropTypes.oneOf([
    'primary',
    'secondary',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
  ]),
  shouldShowControlOption: PropTypes.bool,
  controlOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      handleClick: PropTypes.func.isRequired,
      varient: PropTypes.oneOf(['outline', 'solid']),
    })
  ),
  children: PropTypes.node,
}

export default MessageBanner
